import { ACCESS_CONTROL } from "../access-control/access-control";
import { IconsService } from "../services/icons/icons.service";
import { AppNavigationMenuItem, NAVIGATION_MENU_ITEM_ID, UserNavigationMenuContext } from "./navigation-menu.models";

export function buildAppNavigationMenu(icons: IconsService): readonly AppNavigationMenuItem[] {
    return [
        {
            id: NAVIGATION_MENU_ITEM_ID.DASHBOARD,
            route: ["/dashboard"],
            accessControl: ACCESS_CONTROL.DASHBOARD,
            label: "Dashboard",
            icon: icons.tachometerAlt,
            activeState: { exact: true, ariaCurrent: "page" },
        },
        {
            id: NAVIGATION_MENU_ITEM_ID.ACCOUNTS,
            route: ["/accounts"],
            accessControl: ACCESS_CONTROL.ACCOUNTS,
            label: "Accounts",
            icon: icons.list,
            activeState: { exact: false, ariaCurrent: "location" },
        },
        {
            id: NAVIGATION_MENU_ITEM_ID.CERTIFICATES,
            route: ["/certificates"],
            accessControl: ACCESS_CONTROL.CERTIFICATES,
            label: "Certificates",
            icon: icons.fileCertificate,
            children: [
                {
                    id: NAVIGATION_MENU_ITEM_ID.CERTIFICATES_VIEW,
                    accessControl: ACCESS_CONTROL.CERTIFICATES,
                    label: "View",
                    route: ["/certificates"],
                    icon: icons.fileCertificate,
                    activeState: { exact: false, ariaCurrent: "location" },
                },
                {
                    id: NAVIGATION_MENU_ITEM_ID.CERTIFICATES_REQUEST,
                    label: "Request",
                    route: ["/certificates/request"],
                    icon: icons.commentAlt,
                    activeState: { exact: true, ariaCurrent: "page" },
                    accessControl: ACCESS_CONTROL.CERTIFICATE_MANAGEMENT,
                },
                {
                    id: NAVIGATION_MENU_ITEM_ID.CERTIFICATES_UPLOAD,
                    label: "Upload",
                    route: ["/certificates/upload"],
                    icon: icons.upload,
                    activeState: { exact: true, ariaCurrent: "page" },
                    accessControl: ACCESS_CONTROL.CERTIFICATE_MANAGEMENT,
                },
            ],
        },
        {
            id: NAVIGATION_MENU_ITEM_ID.CERTIFICATE_AUTHORITIES,
            route: ["/cas"],
            accessControl: ACCESS_CONTROL.CERTIFICATE_AUTHORITIES,
            label: "Certificate Authorities",
            icon: icons.lock,
            activeState: { exact: false, ariaCurrent: "location" },
        },
        {
            id: NAVIGATION_MENU_ITEM_ID.REQUESTS,
            route: ["/requests"],
            accessControl: ACCESS_CONTROL.REQUESTS,
            label: "Requests Queue",
            icon: icons.clipboardList,
            activeState: { exact: false, ariaCurrent: "location" },
        },
        {
            id: NAVIGATION_MENU_ITEM_ID.DOMAINS,
            route: ["/domains"],
            accessControl: ACCESS_CONTROL.DOMAINS,
            label: "Domains",
            icon: icons.globe,
            activeState: { exact: false, ariaCurrent: "location" },
        },
        {
            id: NAVIGATION_MENU_ITEM_ID.TLS_DISCOVERY,
            label: "TLS Discovery",
            route: ["/tlsdiscovery/probes"],
            icon: icons.radar,
            accessControl: ACCESS_CONTROL.TLS_DISCOVERY,
            children: [
                {
                    id: NAVIGATION_MENU_ITEM_ID.TLS_DISCOVERY_PROBES,
                    accessControl: ACCESS_CONTROL.TLS_DISCOVERY,
                    label: "Probes",
                    route: ["/tlsdiscovery/probes"],
                    icon: icons.tools,
                    activeState: { exact: false, ariaCurrent: "location" },
                },
            ],
        },
        {
            id: NAVIGATION_MENU_ITEM_ID.USERS,
            route: ["/users"],
            accessControl: ACCESS_CONTROL.USERS,
            label: "Users",
            icon: icons.users,
            activeState: { exact: true, ariaCurrent: "page" },
        },
        {
            id: NAVIGATION_MENU_ITEM_ID.REPORTS,
            route: ["/reports"],
            accessControl: ACCESS_CONTROL.REPORTS,
            label: "Reports",
            icon: icons.report,
            visibleWhen: ({ reports }) => !!reports?.length,
            children: (context: UserNavigationMenuContext) =>
                (context.reports ?? []).map((report) => ({
                    id: `report-${report.id}`,
                    accessControl: ACCESS_CONTROL.REPORTS,
                    label: report.label,
                    route: ["/reports", report.id],
                    icon: icons.report,
                    activeState: { exact: true, ariaCurrent: "page" },
                })),
        },
        {
            id: NAVIGATION_MENU_ITEM_ID.LOGS,
            route: ["/logs"],
            accessControl: ACCESS_CONTROL.LOGS,
            label: "Logs",
            icon: icons.listAlt,
            activeState: { exact: true, ariaCurrent: "page" },
        },
        {
            id: NAVIGATION_MENU_ITEM_ID.HELP,
            route: ["/help"],
            accessControl: ACCESS_CONTROL.HELP,
            label: "Help",
            icon: icons.question,
            activeState: { exact: true, ariaCurrent: "page" },
        },
        {
            id: NAVIGATION_MENU_ITEM_ID.ADMINISTRATION,
            accessControl: ACCESS_CONTROL.ADMIN,
            label: "Admin",
            route: ["/admin/accounts"],
            icon: icons.gear,
            children: [
                {
                    id: NAVIGATION_MENU_ITEM_ID.ADMIN_ACCOUNTS,
                    accessControl: ACCESS_CONTROL.ADMIN,
                    label: "Accounts",
                    route: ["/admin/accounts"],
                    icon: icons.accountAdmin,
                    activeState: { exact: true, ariaCurrent: "page" },
                },
                {
                    id: NAVIGATION_MENU_ITEM_ID.ADMIN_REPORTS,
                    accessControl: ACCESS_CONTROL.ADMIN,
                    label: "Available Reports",
                    route: ["/admin/reports"],
                    icon: icons.report,
                    activeState: { exact: true, ariaCurrent: "page" },
                },
            ],
        },
        {
            id: NAVIGATION_MENU_ITEM_ID.PROFILE,
            route: ["/profile"],
            accessControl: ACCESS_CONTROL.PROFILE,
            label: "Profile",
            icon: icons.userCircleLight,
            activeState: { exact: true, ariaCurrent: "page" },
        },
    ];
}
